module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-pl-PL.d3ab8274.jpg";